import { ScrcpyOptions1_21 } from "../1_21.js";
import { ScrcpyScrollController1_22 } from "./scroll.js";
export class ScrcpyOptions1_22 extends ScrcpyOptions1_21 {
    constructor(init) {
        if (init.rawVideoStream) {
            // Set implied options for client-side processing
            init.sendDeviceMeta = false;
            init.sendFrameMeta = false;
            init.sendDummyByte = false;
        }
        super(init);
    }
    getDefaultValue() {
        return {
            ...super.getDefaultValue(),
            downsizeOnError: true,
            sendDeviceMeta: true,
            sendDummyByte: true,
            rawVideoStream: false,
        };
    }
    getScrollController() {
        return new ScrcpyScrollController1_22();
    }
}
//# sourceMappingURL=options.js.map